// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_a2-0";
export var optionCard = "_a2-1";